import React, { ReactElement, useState } from 'react'

import { IHorario } from 'Models/docas'

import ModalJustificativaAlerta from './ModalJustificativaAlerta'
import ModalVisualizacaoAlertas from './ModalVisualizacaoAlertas'

interface IProps {
  horario: IHorario
}

const ModalAlertas = ({ horario }: IProps): ReactElement => {
  const [justificarAlerta, setJustificarAlerta] = useState<boolean>(false)
  const [cdAlertaOcorrencia, setCdAlertaOcorrencia] = useState<number>(0)
  const [nomeAlerta, setNomeAlerta] = useState<string>('')
  const [justificativaAnterior, setJustificativaAnterior] = useState<string>()

  return (
    <>
      {justificarAlerta ? (
        <ModalJustificativaAlerta
          cdAlertaOcorrencia={cdAlertaOcorrencia}
          nomeAlerta={nomeAlerta}
          setJustificarAlerta={setJustificarAlerta}
          justificativaAnterior={justificativaAnterior}
        />
      ) : (
        <ModalVisualizacaoAlertas
          horario={horario}
          setCdAlertaOcorrencia={setCdAlertaOcorrencia}
          setNomeAlerta={setNomeAlerta}
          setJustificarAlerta={setJustificarAlerta}
          setJustificativaAnterior={setJustificativaAnterior}
        />
      )}
    </>
  )
}

export default ModalAlertas
